// /web/src/components/ModuleProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ModuleProtectedRoute = ({ children, requiredModule, requiredPermission = 'leer' }) => {
  const { isAuthenticated, isAdmin, isLoading } = useContext(AuthContext);
  const location = useLocation();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Verificando autenticación...</p>
      </div>
    );
  }

  // Verificar autenticación básica
  if (!isAuthenticated) {
    console.log('❌ Usuario no autenticado, redirigiendo al login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // **ADMINISTRADORES tienen acceso automático**
  if (isAdmin) {
    return children;
  }

  // **USUARIOS NORMALES:**
  // No verificamos permisos aquí - se verificarán en el backend
  // cuando se hagan peticiones usando el middleware checkModulePermission
  // Si el usuario no tiene permisos, las APIs retornarán 403
  
  //console.log(`✅ Usuario autenticado - Acceso a módulo: ${requiredModule || 'sin restricción'}`);
  return children;
};

export default ModuleProtectedRoute;